import React from "react";
import { ColorSwatch } from "../ColorSwatch/ColorSwatch";
import styles from "./Colors.module.scss";

export function SemanticColors() {
  const colorSections = [
    {
      title: "Text Colors",
      colors: [
        { name: "Text Primary", var: "--color-text-primary" },
        { name: "Text Secondary", var: "--color-text-secondary" },
        { name: "Text Tertiary", var: "--color-text-tertiary" },
        { name: "Text Placeholder", var: "--color-text-placeholder" },
        { name: "Text Inverse", var: "--color-text-inverse" },
        {
          name: "Text Inverse Secondary",
          var: "--color-text-inverse-secondary",
        },
        { name: "Text Inverse Tertiary", var: "--color-text-inverse-tertiary" },
        { name: "Text Selected", var: "--color-text-selected" },
        { name: "Text Disabled", var: "--color-text-disabled" },
        { name: "Text Brand", var: "--color-text-brand" },
        { name: "Text Link", var: "--color-text-link" },
        { name: "Text Link Hover", var: "--color-text-link-hover" },
        { name: "Text Link Pressed", var: "--color-text-link-pressed" },
        { name: "Text Link Mono", var: "--color-text-link-mono" },
        { name: "Text Link Mono Hover", var: "--color-text-link-mono-hover" },
        {
          name: "Text Link Mono Pressed",
          var: "--color-text-link-mono-pressed",
        },
        { name: "Text Alert", var: "--color-text-alert" },
        { name: "Text Alert Hover", var: "--color-text-alert-hover" },
        { name: "Text Alert Pressed", var: "--color-text-alert-pressed" },
        { name: "Text Error", var: "--color-text-error" },
        { name: "Text Error Hover", var: "--color-text-error-hover" },
        { name: "Text Error Pressed", var: "--color-text-error-pressed" },
        { name: "Text Success", var: "--color-text-success" },
        { name: "Text Success Hover", var: "--color-text-success-hover" },
        { name: "Text Success Pressed", var: "--color-text-success-pressed" },
      ],
    },
    {
      title: "Fill Colors",
      colors: [
        { name: "Fill Primary", var: "--color-fill-primary" },
        { name: "Fill Hover", var: "--color-fill-hover" },
        { name: "Fill Pressed", var: "--color-fill-pressed" },
        { name: "Fill Neutral", var: "--color-fill-neutral" },
        { name: "Fill Neutral Hover", var: "--color-fill-neutral-hover" },
        { name: "Fill Neutral Pressed", var: "--color-fill-neutral-pressed" },
        { name: "Fill Selected", var: "--color-fill-selected" },
        { name: "Fill Subtle", var: "--color-fill-subtle" },
        { name: "Fill Inverse", var: "--color-fill-inverse" },
        { name: "Fill Disabled", var: "--color-fill-disabled" },
        { name: "Fill Brand", var: "--color-fill-brand" },
        { name: "Fill Brand Hover", var: "--color-fill-brand-hover" },
        { name: "Fill Brand Pressed", var: "--color-fill-brand-pressed" },
        { name: "Fill Brand Subtle", var: "--color-fill-brand-subtle" },
        {
          name: "Fill Brand Subtle Hover",
          var: "--color-fill-brand-subtle-hover",
        },
        {
          name: "Fill Brand Subtle Pressed",
          var: "--color-fill-brand-subtle-pressed",
        },
        { name: "Fill Info", var: "--color-fill-info" },
        { name: "Fill Info Subtle", var: "--color-fill-info-subtle" },
        { name: "Fill Alert", var: "--color-fill-alert" },
        { name: "Fill Alert Subtle", var: "--color-fill-alert-subtle" },
        { name: "Fill Error", var: "--color-fill-error" },
        { name: "Fill Error Hover", var: "--color-fill-error-hover" },
        { name: "Fill Error Pressed", var: "--color-fill-error-pressed" },
        { name: "Fill Error Subtle", var: "--color-fill-error-subtle" },
        {
          name: "Fill Error Subtle Hover",
          var: "--color-fill-error-subtle-hover",
        },
        {
          name: "Fill Error Subtle Pressed",
          var: "--color-fill-error-subtle-pressed",
        },
        { name: "Fill Success", var: "--color-fill-success" },
        { name: "Fill Success Hover", var: "--color-fill-success-hover" },
        { name: "Fill Success Pressed", var: "--color-fill-success-pressed" },
        { name: "Fill Success Subtle", var: "--color-fill-success-subtle" },
      ],
    },
    {
      title: "Icon Colors",
      colors: [
        { name: "Icon Primary", var: "--color-icon-primary" },
        { name: "Icon Subtle", var: "--color-icon-subtle" },
        { name: "Icon Inverse", var: "--color-icon-inverse" },
        { name: "Icon Selected", var: "--color-icon-selected" },
        { name: "Icon Disabled", var: "--color-icon-disabled" },
        { name: "Icon Brand", var: "--color-icon-brand" },
        { name: "Icon Brand Hover", var: "--color-icon-brand-hover" },
        { name: "Icon Brand Pressed", var: "--color-icon-brand-pressed" },
        { name: "Icon Info", var: "--color-icon-info" },
        { name: "Icon Alert", var: "--color-icon-alert" },
        { name: "Icon High Priority", var: "--color-icon-high-priority" },
        { name: "Icon Error", var: "--color-icon-error" },
        { name: "Icon Error Hover", var: "--color-icon-error-hover" },
        { name: "Icon Error Pressed", var: "--color-icon-error-pressed" },
        { name: "Icon Success", var: "--color-icon-success" },
        { name: "Icon Mono", var: "--color-icon-mono" },
        { name: "Icon Mono Hover", var: "--color-icon-mono-hover" },
        { name: "Icon Mono Pressed", var: "--color-icon-mono-pressed" },
      ],
    },
    {
      title: "Border Colors",
      colors: [
        { name: "Border Primary", var: "--color-border-primary" },
        { name: "Border Subtle", var: "--color-border-subtle" },
        { name: "Border More Subtle", var: "--color-border-more-subtle" },
        { name: "Border Inverse", var: "--color-border-inverse" },
        { name: "Border Selected", var: "--color-border-selected" },
        { name: "Border Disabled", var: "--color-border-disabled" },
        { name: "Border Brand", var: "--color-border-brand" },
        { name: "Border Info", var: "--color-border-info" },
        { name: "Border Alert", var: "--color-border-alert" },
        { name: "Border Error", var: "--color-border-error" },
        { name: "Border Success", var: "--color-border-success" },
      ],
    },
    {
      title: "Surface Colors",
      colors: [
        { name: "Surface L0", var: "--color-surface-l0" },
        { name: "Surface L1", var: "--color-surface-l1" },
        { name: "Surface L2", var: "--color-surface-l2" },
        { name: "Surface L3", var: "--color-surface-l3" },
        { name: "Surface L4", var: "--color-surface-l4" },
        { name: "Surface L5", var: "--color-surface-l5" },
        { name: "Surface L6", var: "--color-surface-l6" },
      ],
    },
    {
      title: "Overlay Colors",
      colors: [
        { name: "Overlay 10", var: "--color-overlay-10" },
        { name: "Overlay 20", var: "--color-overlay-20" },
        { name: "Overlay 30", var: "--color-overlay-30" },
        { name: "Overlay 40", var: "--color-overlay-40" },
        { name: "Overlay 50", var: "--color-overlay-50" },
        { name: "Overlay 60", var: "--color-overlay-60" },
        { name: "Overlay 70", var: "--color-overlay-70" },
        { name: "Overlay 80", var: "--color-overlay-80" },
        { name: "Overlay 90", var: "--color-overlay-90" },
        { name: "Overlay Inverse 10", var: "--color-overlay-inverse-10" },
        { name: "Overlay Inverse 20", var: "--color-overlay-inverse-20" },
        { name: "Overlay Inverse 30", var: "--color-overlay-inverse-30" },
        { name: "Overlay Inverse 40", var: "--color-overlay-inverse-40" },
        { name: "Overlay Inverse 50", var: "--color-overlay-inverse-50" },
        { name: "Overlay Inverse 60", var: "--color-overlay-inverse-60" },
        { name: "Overlay Inverse 70", var: "--color-overlay-inverse-70" },
        { name: "Overlay Inverse 80", var: "--color-overlay-inverse-80" },
        { name: "Overlay Inverse 90", var: "--color-overlay-inverse-90" },
      ],
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.titleContainer}>
          <div className={styles.title}>Semantic Colors</div>
        </div>

        <div className={styles.sectionsGrid}>
          {colorSections.map((section) => (
            <section key={section.title} className={styles.section}>
              <div className={styles.sectionHeader}>
                <div className={styles.sectionTitle}>{section.title}</div>
              </div>
              <div className={styles.colorsGrid}>
                {section.colors.map((color) => (
                  <ColorSwatch
                    key={color.name}
                    name={color.name}
                    colorVar={color.var}
                  />
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
